/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextAlignLeftJustifyIcon64Regular = forwardRef('TextAlignLeftJustifyIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M9.5 11a1.5 1.5 0 0 0 0 3h45a1.5 1.5 0 0 0 0-3h-45Z" }),
        React.createElement("path", { d: "M8 25.5A1.5 1.5 0 0 1 9.5 24h45a1.5 1.5 0 0 1 0 3h-45A1.5 1.5 0 0 1 8 25.5Z" }),
        React.createElement("path", { d: "M9.5 37a1.5 1.5 0 0 0 0 3h45a1.5 1.5 0 0 0 0-3h-45Z" }),
        React.createElement("path", { d: "M9.5 50a1.5 1.5 0 0 0 0 3h25a1.5 1.5 0 0 0 0-3h-25Z" })));
});
